<template>
  <div class="Workbench">
    <el-row :gutter="20">
     <div>您好！欢迎登录宇亨智能医疗物联平台</div>
      <el-button @click="more" type="primary" icon="el-icon-data-line" class="mt-10">数据看板</el-button>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "Workbench",
  data() {
    return {
      myChart: '',
    }
  },
  component: {
    //someComponent
  },
  methods: {
    //
    more() {
      let de = document.documentElement;
      if (de.requestFullscreen) {
        de.requestFullscreen();
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen();
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen();
      }
      this.$router.push("/dataKanban");
    },
  },
  mounted() {
    //
    // this.drawLine()
    // window.onresize = () => {
    //   return (() => {
    //     this.myChart.resize();
    //     this.mis2.resize();
    //     this.mis3.resize();
    //     this.mis4.resize();
    //   })()
    }
}
</script>

<style lang="scss" scoped>
.Workbench {
  .dataCard {
    background: red;
    //border-radius: 4px;
    //text-align: center;
  }
}
</style>